interface EpisodeListProps {
  total: number;
  current: number;
  onSelect: (ep: number) => void;
}

export default function EpisodeList({ total, current, onSelect }: EpisodeListProps) {
  const episodes = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base md:text-lg font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-list-check-2 text-primary-600"></i>
          选集（共 {total} 集）
        </h2>
        <span className="text-xs text-foreground-500 whitespace-nowrap">点击切换播放演示</span>
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1 md:flex-wrap md:overflow-visible">
        {episodes.map((ep) => (
          <button
            key={ep}
            type="button"
            onClick={() => onSelect(ep)}
            className={`shrink-0 w-14 h-10 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              ep === current
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
            }`}
          >
            {ep}
          </button>
        ))}
      </div>
    </div>
  );
}